module.exports = __webpack_public_path__ + "ea594a1f/img/logo-light.621f6443.svg";